import BaseAPI from '../base/baseApi';
import httpClient from '@/apis/base/httpclient';
class DashboardParamApi extends BaseAPI {
  constructor() {
    super();
  }

  controllerName = 'DashboardParams';
  apiName = 'BU';

  /**
   *
   * @param {*} listUpdateExpired
   * @returns
   */
  async updateDashboardParam(listUpdateExpired) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/update-dashboard-param',
      data: listUpdateExpired,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * @description Lưu dữ liệu dashboard param xử lý lấy dữ liệu dashboard mới trả về qua Websocket sau
   * @param {*} payload
   * @returns
   */
  async saveDashBoardParam(payload) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/dashboardParam',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * @description Lấy dữ liệu dashboard mới ngay lập tức
   * @param {*} dashboardkey
   * @returns
   */
  async handleDashboardParamImmediately(payload) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/dashboardParamImmediately',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new DashboardParamApi();
